var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app-bar",
    { staticClass: "app-style", attrs: { app: "", dark: "", height: "70px" } },
    [
      _vm._l(_vm.navTabs(), function (tab, i) {
        return _c(
          "v-tooltip",
          {
            key: tab.to,
            attrs: { bottom: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "activator",
                  fn: function ({ on, attrs }) {
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              attrs: {
                                disabled: tab.disabled,
                                to: tab.to,
                                icon: "",
                                color: "white",
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v(_vm._s(tab.icon)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          },
          [_c("span", [_vm._v(_vm._s(tab.label))])]
        )
      }),
      _vm.isRedactorRoute && _vm.configUID
        ? [
            _c("v-divider", { attrs: { vertical: "" } }),
            _c("div", { staticClass: "ac__header-info" }, [
              _c("div", { staticClass: "ac__header-info-item" }, [
                _c(
                  "div",
                  { staticClass: "ac__header-info-item-title" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "ml-1", attrs: { small: "" } },
                      [_vm._v("mdi-cog")]
                    ),
                    _c("span", { staticClass: "mr-1" }, [_vm._v("Config ID:")]),
                  ],
                  1
                ),
                _c("span", [_vm._v(_vm._s(_vm.configUID))]),
              ]),
              _vm.globalUID
                ? _c("div", { staticClass: "ac__header-info-item" }, [
                    _c(
                      "div",
                      { staticClass: "ac__header-info-item-title" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "ml-1", attrs: { small: "" } },
                          [_vm._v("mdi-earth")]
                        ),
                        _c("span", { staticClass: "mr-1" }, [
                          _vm._v("Global ID:"),
                        ]),
                      ],
                      1
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.globalUID))]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "ac__header-info-item" }, [
                _c(
                  "div",
                  { staticClass: "ac__header-info-item-title" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "ml-1", attrs: { small: "" } },
                      [_vm._v("mdi-map-marker")]
                    ),
                    _c("span", { staticClass: "mr-1" }, [_vm._v("Map ID:")]),
                  ],
                  1
                ),
                _c("span", [_vm._v(_vm._s(_vm.mapID || "No Map ID added"))]),
              ]),
            ]),
          ]
        : _vm._e(),
      _c("v-spacer"),
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: { icon: "", color: "white" },
                          on: { click: _vm.onLogout },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [
                        _vm._v("mdi-logout"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("Logout")])]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }